import React, { useState, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, Col, Row } from 'reactstrap';
import firebase from '../../config/firebase.config';
import { nonActiveSubscriptionStates } from '@/layouts';

const database = firebase.firestore();

const SubscriptionSuspendedPage = () => {
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const companyId = new URLSearchParams(location.search).get('companyId');
  const authState = useSelector((state) => ({ ...state.auth }));
  const subscription = authState?.profile?.subscription;
  const { heading, description } = useMemo(() => {
    let heading = 'Trial Expired';
    let description =
      'Your trial period has ended. Please Choose a plan to continue using the application.';
    const wasSubscriptionActive =
      subscription?.subscriptionEndDate &&
      new Date(subscription?.subscriptionEndDate?.seconds * 1000) < new Date();
    if (wasSubscriptionActive) {
      heading = 'Subscription Suspended';
      description =
        'Your subscription for this company has been suspended. Please choose a plan to continue using the application.';
    }
    const isNonActiveSubscription = nonActiveSubscriptionStates.includes(
      subscription?.status
    );
    if (isNonActiveSubscription) {
      heading = 'No Subscription Found';
      description =
        'No active subscription found for this company. Please choose a plan to continue using the application.';
    }

    return { heading, description };
  }, [subscription]);
  // useEffect(() => {
  //   const fetchCompanyData = async () => {
  //     try {
  //       if (companyId) {
  //         const companyDoc = await database
  //           .collection('companyDatabase')
  //           .doc(companyId)
  //           .get();

  //         if (companyDoc.exists) {
  //           const data = companyDoc.data();
  //           setCompanyData(data);

  //           // Check if subscription is actually active - redirect if it is
  //           if (data.subscriptionStatus === 'active') {
  //             console.log('Subscription: Found active subscription on suspended page - redirecting to dashboard');
  //             history.push('/dashboard-team');
  //             return;
  //           }

  //           // Check if trial is still valid - redirect if it is
  //           if (data.subscriptionStatus === 'trial' && data.trialExpiryDate) {
  //             const trialExpiryDate = new Date(data.trialExpiryDate);
  //             const now = new Date();
  //             if (trialExpiryDate > now) {
  //               console.log('Subscription: Found valid trial on suspended page - redirecting to dashboard');
  //               history.push('/dashboard-team');
  //               return;
  //             }
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       console.error('Error fetching company data:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchCompanyData();
  // }, [companyId, history]);

  // const handlePaymentClick = () => {
  //   history.push(`/payment?companyId=${companyId}`);
  // };

  // const handleLogout = () => {
  //   dispatch({ type: "user/LOGOUT_ACTIVE_ACCOUNT" });
  // };

  // const handleSelectDifferentCompany = () => {
  //   history.push('/select-company');
  // };

  // if (loading) {
  //   return (
  //     <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
  //       <div className="spinner-border text-primary" role="status">
  //         <span className="sr-only">Loading...</span>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div
      className="subscription-suspended-page"
      style={{
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Row className="justify-content-center w-100">
        <Col lg="6" md="8" sm="10">
          <Card className="shadow-lg border-0">
            <CardBody className="text-center p-5">
              <div className="mb-4">
                <i
                  className="ni ni-money-coins text-danger"
                  style={{ fontSize: '4rem' }}
                ></i>
              </div>

              <h2 className="text-danger mb-3">{heading}</h2>

              <p className="text-muted mb-4" style={{ fontSize: '1.1rem' }}>
                {description}
              </p>

              <div className="mt-4">
                <button
                  className="btn btn-primary btn-lg"
                  onClick={() => history.push('/subscription?from=suspended')}
                >
                  <i className="ni ni-money-coins mr-2"></i>
                  Choose a Plan
                </button>
              </div>

              <div className="mt-4">
                <small className="text-muted">
                  Need help? Contact our support team for assistance.
                </small>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SubscriptionSuspendedPage;
